module.exports = __webpack_public_path__ + "img/UI_loading_H5BG_02_4b27e2802.jpg";